// This file is auto-generated by @hey-api/openapi-ts
import { type UseMutationOptions, queryOptions } from '@tanstack/react-query';
import { client } from '../client.gen';
import {
    type Options,
    alternateDatesSearch,
    availabilitySearch,
    cancelQuote,
    cancelReservation,
    convertQuote,
    createBooking,
    createFerryQuote,
    emailQuote,
    fetchBooking,
    findReservation,
    getCountries,
    getFerryBooking,
    getFerryBookings,
    getFerryOptions,
    getFerryQuote,
    getFerryRoutes,
    getFerrySailings,
    getFerryStatus,
    getFerryTimetable,
    getFleetCategories,
    getFleetCategoryByCode,
    getFleetTypeBySlug,
    getFleetTypes,
    getMinimumHirePeriods,
    getOptions,
    getRentalCatalog,
    getSiteByCode,
    listHirePeriods,
    listSites,
    tripInfo,
    updateFerryQuote,
    updateQuote,
    updateReservation,
    validateUpdateReservation,
} from '../sdk.gen';
import type {
    AlternateDatesSearchData,
    AvailabilitySearchData,
    CancelQuoteData,
    CancelQuoteError,
    CancelQuoteResponse,
    CancelReservationData,
    CancelReservationError,
    CancelReservationResponse2 as CancelReservationResponse,
    ConvertQuoteData,
    CreateBookingData,
    CreateBookingError,
    CreateBookingResponse2 as CreateBookingResponse,
    CreateFerryQuoteData,
    CreateFerryQuoteError,
    CreateFerryQuoteResponse,
    EmailQuoteData,
    EmailQuoteError,
    EmailQuoteResponse,
    FetchBookingData,
    FindReservationData,
    FindReservationError,
    FindReservationResponse,
    GetCountriesData,
    GetFerryBookingData,
    GetFerryBookingsData,
    GetFerryOptionsData,
    GetFerryQuoteData,
    GetFerryRoutesData,
    GetFerrySailingsData,
    GetFerrySailingsError,
    GetFerrySailingsResponse,
    GetFerryStatusData,
    GetFerryTimetableData,
    GetFleetCategoriesData,
    GetFleetCategoryByCodeData,
    GetFleetTypeBySlugData,
    GetFleetTypesData,
    GetMinimumHirePeriodsData,
    GetOptionsData,
    GetRentalCatalogData,
    GetSiteByCodeData,
    ListHirePeriodsData,
    ListSitesData,
    TripInfoData,
    UpdateFerryQuoteData,
    UpdateFerryQuoteError,
    UpdateFerryQuoteResponse,
    UpdateQuoteData,
    UpdateQuoteError,
    UpdateQuoteResponse,
    UpdateReservationData,
    UpdateReservationError,
    UpdateReservationResponse,
    ValidateUpdateReservationData,
    ValidateUpdateReservationError,
    ValidateUpdateReservationResponse,
} from '../types.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
        tags?: ReadonlyArray<string>;
    },
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean, tags?: ReadonlyArray<string>): [QueryKey<TOptions>[0]] => {
    const params: QueryKey<TOptions>[0] = {
        _id: id,
        baseUrl: options?.baseUrl || (options?.client ?? client).getConfig().baseUrl,
    } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (tags) {
        params.tags = tags;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [params];
};

export const listHirePeriodsQueryKey = (options?: Options<ListHirePeriodsData>) => createQueryKey('listHirePeriods', options);

/**
 * Get hire periods information
 */
export const listHirePeriodsOptions = (options?: Options<ListHirePeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listHirePeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: listHirePeriodsQueryKey(options),
    });
};

export const getCountriesQueryKey = (options?: Options<GetCountriesData>) => createQueryKey('getCountries', options);

/**
 * Get a list of countries
 */
export const getCountriesOptions = (options?: Options<GetCountriesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCountries({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getCountriesQueryKey(options),
    });
};

export const getMinimumHirePeriodsQueryKey = (options?: Options<GetMinimumHirePeriodsData>) => createQueryKey('getMinimumHirePeriods', options);

/**
 * List current hire periods
 */
export const getMinimumHirePeriodsOptions = (options?: Options<GetMinimumHirePeriodsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMinimumHirePeriods({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getMinimumHirePeriodsQueryKey(options),
    });
};

export const getFleetCategoriesQueryKey = (options?: Options<GetFleetCategoriesData>) => createQueryKey('getFleetCategories', options);

/**
 * Get a list of fleet categories
 */
export const getFleetCategoriesOptions = (options?: Options<GetFleetCategoriesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFleetCategories({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFleetCategoriesQueryKey(options),
    });
};

export const getFleetTypesQueryKey = (options?: Options<GetFleetTypesData>) => createQueryKey('getFleetTypes', options);

/**
 * Get a list of fleet types
 */
export const getFleetTypesOptions = (options?: Options<GetFleetTypesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFleetTypes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFleetTypesQueryKey(options),
    });
};

/**
 * Create a new quote and email it to the hirer
 */
export const emailQuoteMutation = (options?: Partial<Options<EmailQuoteData>>): UseMutationOptions<EmailQuoteResponse, EmailQuoteError, Options<EmailQuoteData>> => {
    const mutationOptions: UseMutationOptions<EmailQuoteResponse, EmailQuoteError, Options<EmailQuoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await emailQuote({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getRentalCatalogQueryKey = (options?: Options<GetRentalCatalogData>) => createQueryKey('getRentalCatalog', options);

/**
 * Get a list of rental products
 */
export const getRentalCatalogOptions = (options?: Options<GetRentalCatalogData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRentalCatalog({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getRentalCatalogQueryKey(options),
    });
};

/**
 * Find your reservation
 */
export const findReservationMutation = (options?: Partial<Options<FindReservationData>>): UseMutationOptions<FindReservationResponse, FindReservationError, Options<FindReservationData>> => {
    const mutationOptions: UseMutationOptions<FindReservationResponse, FindReservationError, Options<FindReservationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await findReservation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

/**
 * Create a new booking
 */
export const createBookingMutation = (options?: Partial<Options<CreateBookingData>>): UseMutationOptions<CreateBookingResponse, CreateBookingError, Options<CreateBookingData>> => {
    const mutationOptions: UseMutationOptions<CreateBookingResponse, CreateBookingError, Options<CreateBookingData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createBooking({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const listSitesQueryKey = (options?: Options<ListSitesData>) => createQueryKey('listSites', options);

/**
 * Get branch information
 */
export const listSitesOptions = (options?: Options<ListSitesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await listSites({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: listSitesQueryKey(options),
    });
};

export const alternateDatesSearchQueryKey = (options: Options<AlternateDatesSearchData>) => createQueryKey('alternateDatesSearch', options);

/**
 * Search for availability and pricing for alternative dates
 */
export const alternateDatesSearchOptions = (options: Options<AlternateDatesSearchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await alternateDatesSearch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: alternateDatesSearchQueryKey(options),
    });
};

export const availabilitySearchQueryKey = (options: Options<AvailabilitySearchData>) => createQueryKey('availabilitySearch', options);

/**
 * Search for availability and pricing
 */
export const availabilitySearchOptions = (options: Options<AvailabilitySearchData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await availabilitySearch({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: availabilitySearchQueryKey(options),
    });
};

export const tripInfoQueryKey = (options: Options<TripInfoData>) => createQueryKey('tripInfo', options);

/**
 * Get pricing, extras and insurance options for a trip
 */
export const tripInfoOptions = (options: Options<TripInfoData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await tripInfo({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: tripInfoQueryKey(options),
    });
};

export const getFerryOptionsQueryKey = (options: Options<GetFerryOptionsData>) => createQueryKey('getFerryOptions', options);

/**
 * Get ferry options
 */
export const getFerryOptionsOptions = (options: Options<GetFerryOptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFerryOptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFerryOptionsQueryKey(options),
    });
};

export const getFerryRoutesQueryKey = (options: Options<GetFerryRoutesData>) => createQueryKey('getFerryRoutes', options);

/**
 * Get available ferry routes
 */
export const getFerryRoutesOptions = (options: Options<GetFerryRoutesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFerryRoutes({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFerryRoutesQueryKey(options),
    });
};

/**
 * Get available ferry sailings
 */
export const getFerrySailingsMutation = (
    options?: Partial<Options<GetFerrySailingsData>>
): UseMutationOptions<GetFerrySailingsResponse, GetFerrySailingsError, Options<GetFerrySailingsData>> => {
    const mutationOptions: UseMutationOptions<GetFerrySailingsResponse, GetFerrySailingsError, Options<GetFerrySailingsData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await getFerrySailings({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getFerryStatusQueryKey = (options: Options<GetFerryStatusData>) => createQueryKey('getFerryStatus', options);

/**
 * Get ferry status for given reservation
 */
export const getFerryStatusOptions = (options: Options<GetFerryStatusData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFerryStatus({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFerryStatusQueryKey(options),
    });
};

export const getFerryTimetableQueryKey = (options: Options<GetFerryTimetableData>) => createQueryKey('getFerryTimetable', options);

/**
 * Get ferry timetable
 */
export const getFerryTimetableOptions = (options: Options<GetFerryTimetableData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFerryTimetable({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFerryTimetableQueryKey(options),
    });
};

export const getFleetCategoryByCodeQueryKey = (options: Options<GetFleetCategoryByCodeData>) => createQueryKey('getFleetCategoryByCode', options);

/**
 * Get fleet category information
 */
export const getFleetCategoryByCodeOptions = (options: Options<GetFleetCategoryByCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFleetCategoryByCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFleetCategoryByCodeQueryKey(options),
    });
};

export const getFleetTypeBySlugQueryKey = (options: Options<GetFleetTypeBySlugData>) => createQueryKey('getFleetTypeBySlug', options);

/**
 * Get fleet type information
 */
export const getFleetTypeBySlugOptions = (options: Options<GetFleetTypeBySlugData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFleetTypeBySlug({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFleetTypeBySlugQueryKey(options),
    });
};

/**
 * Cancel an existing quote
 */
export const cancelQuoteMutation = (options?: Partial<Options<CancelQuoteData>>): UseMutationOptions<CancelQuoteResponse, CancelQuoteError, Options<CancelQuoteData>> => {
    const mutationOptions: UseMutationOptions<CancelQuoteResponse, CancelQuoteError, Options<CancelQuoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelQuote({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const convertQuoteQueryKey = (options: Options<ConvertQuoteData>) => createQueryKey('convertQuote', options);

/**
 * Convert a quote in to a reservation
 */
export const convertQuoteOptions = (options: Options<ConvertQuoteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await convertQuote({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: convertQuoteQueryKey(options),
    });
};

/**
 * Make updates and edit an existing quote
 */
export const updateQuoteMutation = (options?: Partial<Options<UpdateQuoteData>>): UseMutationOptions<UpdateQuoteResponse, UpdateQuoteError, Options<UpdateQuoteData>> => {
    const mutationOptions: UseMutationOptions<UpdateQuoteResponse, UpdateQuoteError, Options<UpdateQuoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateQuote({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

/**
 * Cancel an existing reservation
 */
export const cancelReservationMutation = (
    options?: Partial<Options<CancelReservationData>>
): UseMutationOptions<CancelReservationResponse, CancelReservationError, Options<CancelReservationData>> => {
    const mutationOptions: UseMutationOptions<CancelReservationResponse, CancelReservationError, Options<CancelReservationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await cancelReservation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const fetchBookingQueryKey = (options: Options<FetchBookingData>) => createQueryKey('fetchBooking', options);

/**
 * Fetch a booking
 */
export const fetchBookingOptions = (options: Options<FetchBookingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await fetchBooking({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: fetchBookingQueryKey(options),
    });
};

/**
 * Make updates and edit an existing reservation
 */
export const updateReservationMutation = (
    options?: Partial<Options<UpdateReservationData>>
): UseMutationOptions<UpdateReservationResponse, UpdateReservationError, Options<UpdateReservationData>> => {
    const mutationOptions: UseMutationOptions<UpdateReservationResponse, UpdateReservationError, Options<UpdateReservationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateReservation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getOptionsQueryKey = (options: Options<GetOptionsData>) => createQueryKey('getOptions', options);

/**
 * Return options available for a booking
 */
export const getOptionsOptions = (options: Options<GetOptionsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getOptions({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getOptionsQueryKey(options),
    });
};

/**
 * Validate the update reservation
 */
export const validateUpdateReservationMutation = (
    options?: Partial<Options<ValidateUpdateReservationData>>
): UseMutationOptions<ValidateUpdateReservationResponse, ValidateUpdateReservationError, Options<ValidateUpdateReservationData>> => {
    const mutationOptions: UseMutationOptions<ValidateUpdateReservationResponse, ValidateUpdateReservationError, Options<ValidateUpdateReservationData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await validateUpdateReservation({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getSiteByCodeQueryKey = (options: Options<GetSiteByCodeData>) => createQueryKey('getSiteByCode', options);

/**
 * Get branch information
 */
export const getSiteByCodeOptions = (options: Options<GetSiteByCodeData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getSiteByCode({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getSiteByCodeQueryKey(options),
    });
};

export const getFerryBookingsQueryKey = (options: Options<GetFerryBookingsData>) => createQueryKey('getFerryBookings', options);

/**
 * Get all ferry bookings for a given reservation
 */
export const getFerryBookingsOptions = (options: Options<GetFerryBookingsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFerryBookings({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFerryBookingsQueryKey(options),
    });
};

/**
 * Create ferry booking quote
 */
export const createFerryQuoteMutation = (
    options?: Partial<Options<CreateFerryQuoteData>>
): UseMutationOptions<CreateFerryQuoteResponse, CreateFerryQuoteError, Options<CreateFerryQuoteData>> => {
    const mutationOptions: UseMutationOptions<CreateFerryQuoteResponse, CreateFerryQuoteError, Options<CreateFerryQuoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await createFerryQuote({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};

export const getFerryBookingQueryKey = (options: Options<GetFerryBookingData>) => createQueryKey('getFerryBooking', options);

/**
 * Get a ferry booking
 */
export const getFerryBookingOptions = (options: Options<GetFerryBookingData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFerryBooking({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFerryBookingQueryKey(options),
    });
};

export const getFerryQuoteQueryKey = (options: Options<GetFerryQuoteData>) => createQueryKey('getFerryQuote', options);

/**
 * Retrieve ferry booking quote
 */
export const getFerryQuoteOptions = (options: Options<GetFerryQuoteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getFerryQuote({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true,
            });
            return data;
        },
        queryKey: getFerryQuoteQueryKey(options),
    });
};

/**
 * Update ferry booking quote
 */
export const updateFerryQuoteMutation = (
    options?: Partial<Options<UpdateFerryQuoteData>>
): UseMutationOptions<UpdateFerryQuoteResponse, UpdateFerryQuoteError, Options<UpdateFerryQuoteData>> => {
    const mutationOptions: UseMutationOptions<UpdateFerryQuoteResponse, UpdateFerryQuoteError, Options<UpdateFerryQuoteData>> = {
        mutationFn: async (fnOptions) => {
            const { data } = await updateFerryQuote({
                ...options,
                ...fnOptions,
                throwOnError: true,
            });
            return data;
        },
    };
    return mutationOptions;
};
